module.exports = __webpack_public_path__ + "img/pending.2a6ac7ae.svg";